import Breakpoints from './Breakpoints';

export default Breakpoints;
